import { i18n } from "@lingui/core";
import {
  DEFAULT_LOCALE,
  LOCALES,
  LOCALE_STORAGE_KEY,
  detectLocale,
  type Locale,
} from "@sage-mcp/shared";
import { messages as enMessages } from "./locales/en/messages.po";
import { messages as frMessages } from "./locales/fr/messages.po";

const CATALOGS: Record<Locale, Record<string, string>> = {
  en: enMessages,
  fr: frMessages,
};

for (const locale of LOCALES) {
  i18n.load(locale, CATALOGS[locale]);
}

function loadInitialLocale(): Locale {
  try {
    const stored = window.localStorage.getItem(LOCALE_STORAGE_KEY);
    if (stored) return detectLocale(stored);
  } catch {
    /* localStorage unavailable — fall back to browser */
  }
  return detectLocale(typeof navigator !== "undefined" ? navigator.language : null);
}

export function activateLocale(locale: Locale): void {
  i18n.activate(locale);
  try {
    window.localStorage.setItem(LOCALE_STORAGE_KEY, locale);
  } catch {
    /* ignore */
  }
}

export function getActiveLocale(): Locale {
  const active = i18n.locale;
  return (LOCALES as readonly string[]).includes(active) ? (active as Locale) : DEFAULT_LOCALE;
}

activateLocale(loadInitialLocale());

export { i18n };
